import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isText } from "../../Util/Util/validations.js";
const FirstName = ({
  label,
  errorMessage,
  validations = [isText],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "firstName",
    "data-t": "first-name",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  FirstName as default
};
//# sourceMappingURL=FirstName.js.map
